import { Component, OnInit } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import * as XLSX from 'xlsx';
import { ApiService } from 'src/app/shared/services/api.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { MatModule } from 'src/app/appModules/mat.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

interface YearOption {
  value: string;
  Text: string;
}
@Component({
  selector: 'app-result-import',
  standalone: true,
  imports: [CommonModule, MatModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatFormFieldModule, CommonModule],
  templateUrl: './result-import.component.html'
})
export class ResultImportComponent implements OnInit {

  @ViewChild('fileInput') fileInput!: ElementRef;
  resultSummary: any[] = [];
  groupedResultSummary = [];
  //  summaryDisplayedColumns: string[] = ['exam_month', 'exam_year', 'semester_number', 'result_type', 'count'];
  summaryDisplayedColumns = ['exam_month', 'exam_year', 'semester_number', 'result_type', 'count'];

  resultType: string = 'regular'; // default value
  selectedExcelColumns: { [key: string]: string } = {}; // key = dbField, value = selected excel column
  modelFields: string[] = [
    'sl_no',
    'register_no',
    'name',
    'surname',

    'crs_code',
    'app',
    'semester_number',
    'pathway',
    'pathway_sub',
    'ia_sub1',
    'see_sub1',
    'total_sub1',
    'result_sub1',

    'see_sub1p',
    'result_sub1p',

    'ia_sub2',
    'see_sub2',
    'total_sub2',
    'result_sub2',

    'see_sub2p',
    'result_sub2p',

    'ia_sub3',
    'see_sub3',
    'total_sub3',
    'result_sub3',

    'see_sub3p',
    'result_sub3p',

    'ia_sub4',
    'see_sub4',
    'total_sub4',
    'result_sub4',

    'ia_sub5',
    'see_sub5',
    'total_sub5',
    'result_sub5',

    'k_sub5',

    'ia_sub6',
    'see_sub6',
    'total_sub6',
    'result_sub6',

    'ia_sub7',
    'see_sub7',
    'total_sub7',
    'result_sub7',

    'ia_sub8',
    'see_sub8',
    'total_sub8',
    'result_sub8',

    'overall_remark',

    'overall_total',
    'overall_result',
    'SFC1',
    'SFC2',
    'SFC3',
    'SFC4',
    'SFC5',
    'SFC6',
    'SFC7',
    'SFCTOT',
    'NC'
  ];
  columnHeaders: string[] = []; // Excel column headers
  columnMapping: { [key: string]: string } = {}; // ExcelHeader -> modelField


  excelData: any[] = [];
  invalidRows: any[] = [];
  courseList: any[] = [];
  semesterList: any[] = [];
  selectedCourseId: any = null;
  selectedCourseCode: any = null;
  selectedSemester: any = null;
  examMonth: string = '';
  examYear: string = '';
  importSummary: any = null;
  importSkipped: any[] = [];
  range: number[] = [];
  years: any;
  months: any;


  constructor(private api: ApiService, private common: CommonService) { }

  ngOnInit(): void {
    this.year_list();
    this.month_list();
    this.api.get('courses/list').subscribe(res => {
      if (res.success) this.courseList = res.data;
    });

    this.api.get('semesters/list').subscribe(res => {
      if (res.success) this.semesterList = res.data;
    });
    const currentYear = new Date().getFullYear();
    this.range = Array.from({ length: 10 }, (_, i) => currentYear - i);
  }

  onFileChange(evt: any) {
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) return;

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const workbook: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      // Extract headers from first row
      const raw = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '' });
      this.columnHeaders = raw[0] as string[];

      // Store data as JSON with default headers
      this.excelData = XLSX.utils.sheet_to_json(sheet, { defval: '' });

      // Initialize column mapping with empty values
      this.columnMapping = {};
      this.columnHeaders.forEach(header => {
        this.columnMapping[header] = ''; // let user choose
      });

      // Load saved mappings (if course/semester already selected)
      if (this.selectedCourseId && this.selectedSemester) {
        this.loadSavedColumnMappings();
      }
      this.validateData();
    };
    reader.readAsBinaryString(target.files[0]);
  }

  validateData() {
    this.invalidRows = [];

    this.excelData.forEach((row, index) => {
      const rowNumber = index + 2; // +2 to account for header row

      if (!this.selectedCourseId) {
        this.invalidRows.push(`Row ${rowNumber}: Course not selected`);
      }

      if (!this.selectedSemester) {
        this.invalidRows.push(`Row ${rowNumber}: Semester not selected`);
      }

      // Validate if CRSCODE matches selected course code
      if (this.selectedCourseCode && row['CRSCODE']?.toString().trim() !== this.selectedCourseCode.toString().trim()) {
        this.invalidRows.push(`Row ${rowNumber}: CRSCODE '${row['CRSCODE']}' does not match selected course code '${this.selectedCourseCode}'`);
      }

      // Validate all mapped fields
      const missingFields: string[] = [];

      for (const [excelCol, modelField] of Object.entries(this.columnMapping)) {
        if (modelField) {
          const value = row[excelCol];
          if (value === undefined || value === null || value.toString().trim() === '') {
            missingFields.push(modelField);
          }
        }
      }

      if (missingFields.length > 0) {
        this.invalidRows.push(`Row ${rowNumber}: Missing or empty fields: ${[...new Set(missingFields)].join(', ')}`);
      }
    });
  }



  importResults() {
    if (this.invalidRows.length > 0) {
      alert('Fix validation errors before importing.');
      return;
    }

    const schemeType = 'C-21';

    const mappedData = this.excelData.map(row => {
      const mappedRow: any = {
        course_id: this.selectedCourseId,
        semester_number: this.selectedSemester,
        exam_month: this.examMonth,
        exam_year: this.examYear,
        scheme_type: schemeType,
        result_type: this.resultType
      };

      for (const [excelCol, modelField] of Object.entries(this.columnMapping)) {
        if (modelField) {
          mappedRow[modelField] = row[excelCol];
        }
      }

      return mappedRow;
    });
    console.log('maped dta', mappedData);
    

    // Prepare column mappings to send
    const columnMappings = Object.entries(this.columnMapping)
      .filter(([excelCol, mappedField]) => mappedField)
      .map(([excelCol, mappedField]) => ({
        course_id: this.selectedCourseId,
        semester_number: this.selectedSemester,
        scheme_type: schemeType,
        result_type: this.resultType,
        excel_column: excelCol,
        mapped_field: mappedField
      }));

    const payload = {
      results: mappedData,
      mappings: columnMappings
    };
    console.log('pauyload', payload, mappedData, columnMappings);
    console.log('mappedData',mappedData);
    console.log('columnMappings',columnMappings );
    
    this.api.post('results/import', payload).subscribe(resp => {
      if (resp && resp.success) {
        console.log(resp.data);
        console.log(resp.success);
        this.importSummary = resp.summary;
        this.importSkipped = resp.skipped;
        this.invalidRows = resp.invalidRows;
        this.common.notification(resp.message);
        this.reset();
        this.fetchResultSummary({ courseId: this.selectedCourseId });
      } else {
        this.common.notification(resp.message, true);
      }
    });
  }

  replaceResults() {
    if (this.invalidRows.length > 0) {
      alert('Fix validation errors before importing.');
      return;
    }

    const schemeType = 'C-21';

    const mappedData = this.excelData.map(row => {
      const mappedRow: any = {
        course_id: this.selectedCourseId,
        semester_number: this.selectedSemester,
        exam_month: this.examMonth,
        exam_year: this.examYear,
        scheme_type: schemeType,
        result_type: this.resultType
      };

      for (const [excelCol, modelField] of Object.entries(this.columnMapping)) {
        if (modelField) {
          mappedRow[modelField] = row[excelCol];
        }
      }

      return mappedRow;
    });

    // Prepare column mappings to send
    const columnMappings = Object.entries(this.columnMapping)
      .filter(([excelCol, mappedField]) => mappedField)
      .map(([excelCol, mappedField]) => ({
        course_id: this.selectedCourseId,
        semester_number: this.selectedSemester,
        scheme_type: schemeType,
        result_type: this.resultType,
        excel_column: excelCol,
        mapped_field: mappedField
      }));

    const payload = {
      results: mappedData,
      mappings: columnMappings
    };

    this.api.post('results/replace', payload).subscribe(resp => {
      if (resp && resp.success) {
        this.importSummary = resp.summary;
        this.importSkipped = resp.skipped;
        this.invalidRows = resp.invalidRows;
        this.common.notification(resp.message);
        this.reset();
        this.fetchResultSummary({ courseId: this.selectedCourseId });
      } else {
        this.common.notification(resp.message, true);
      }
    });
  }


  reset() {
    this.excelData = [];
    this.columnHeaders = [];
    this.columnMapping = {};
    this.selectedCourseId = null;
    this.selectedSemester = null;
    this.examMonth = '';
    this.examYear = '';

    // Clear the file input to allow re-selecting the same file
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }




  getAvailableFields(currentCol: string): string[] {
    const usedFields = Object.entries(this.columnMapping)
      .filter(([col, field]) => col !== currentCol && field !== '')
      .map(([_, field]) => field);
    return this.modelFields.filter(field => !usedFields.includes(field));
  }

  loadSavedColumnMappings() {
    if (!this.selectedCourseId || !this.selectedSemester) return;

    const params = {
      course_id: this.selectedCourseId,
      semester_number: this.selectedSemester,
      scheme_type: 'C-21',
      result_type: this.resultType
    };

    const url = `results/mapping/list?course_id=${this.selectedCourseId}&semester_number=${this.selectedSemester}&scheme_type=C-21&result_type=${this.resultType}`;

    this.api.get(url).subscribe(res => {
      if (res.success && Array.isArray(res.data)) {
        // Clear existing mapping
        for (const col of this.columnHeaders) {
          this.columnMapping[col] = '';
        }

        // Apply saved mappings
        for (const mapping of res.data) {
          const { excel_column, mapped_field } = mapping;
          if (this.columnHeaders.includes(excel_column)) {
            this.columnMapping[excel_column] = mapped_field;
          }
        }

        this.common.notification('Previous column mappings loaded.');
      }
    });
  }

  onCourseChange(courseId: number) {
      const selectedCourse = this.courseList.find(course => course.id === courseId);
  if (selectedCourse) {
    this.selectedCourseCode = selectedCourse.crs_code;
  } else {
    this.selectedCourseCode = null;
  }
    // Call the fetchResultSummary function when course changes
    this.fetchResultSummary({ courseId: courseId });
  }

  fetchResultSummary(payload: any) {
    this.api.post('results/summary', { ...payload }).subscribe({
      next: (res: any) => {
        if (res.success) this.resultSummary = res.data;
      },
      error: (err) => {
        console.error('Error fetching summary:', err);
      }
    });
  }

  public cYear: number = new Date().getFullYear();

  public currentYear: Array<YearOption> = [
    { value: "0", Text: "Select" },
    { value: this.cYear.toString(), Text: this.cYear.toString() },
    { value: (this.cYear - 1).toString(), Text: (this.cYear - 1).toString() },
    { value: (this.cYear - 2).toString(), Text: (this.cYear - 2).toString() },
    { value: (this.cYear - 3).toString(), Text: (this.cYear - 3).toString() },
    { value: (this.cYear - 4).toString(), Text: (this.cYear - 4).toString() },
    { value: (this.cYear - 5).toString(), Text: (this.cYear - 5).toString() },
    { value: (this.cYear - 6).toString(), Text: (this.cYear - 6).toString() }
  ];

  year_list() {
    this.api.get('settings/year_list').subscribe({
      next: (resp) => {
        if (resp.success) {
          this.years = resp.data
          console.log('Year list fetched', resp.data);
        }
      },
      error: (err) => {
        console.error('Error fetching year list:', err);
      }
    });
  }

  month_list() {
    this.api.get('settings/month_list').subscribe({
      next: (resp) => {
        if (resp.success) {
          this.months = resp.data
          console.log('Year list fetched', resp.data);
        }
      },
      error: (err) => {
        console.error('Error fetching year list:', err);
      }
    });
  }

}
